<template>
  <div :class="isSignUpPhase3Route ? 'mt-xxs' : 'mt-3'">
    <h5
      v-if="!isSignUpPhase3Route"
      class="mb-0">
      {{ subscribeSourcePrompt }}<span class="required-asterisk">*</span>
    </h5>
    <p
      v-else
      class="small-text semi-bold mb-0">
      {{ subscribeSourcePrompt }}
    </p>
    <div
      :class="[{'mobile flex-wrap': isMobile, 'rejoin flex-wrap': isRejoin}, isSignUpPhase3Route ? 'pt-sm' : 'py-lg']"
      class="d-flex">
      <dropdown-single-select
        :model-value="leadSource"
        class="leadSource w-100"
        :class="{'mobile': isMobile, 'rejoin': isRejoin }"
        small
        :dropdown-options="subscribeSourceOptions"
        :initial-selection-index="leadSource ? selectionIndex : null"
        @update:modelValue="onLeadSourceUpdate"/>
      <base-input
        v-if="leadSource && subscribeSourceDetailPrompt"
        v-model="leadSourceDetail"
        :validations="v$.leadSourceDetail"
        class="w-100"
        :class="{'mobile': isMobile, 'rejoin': isRejoin}"
        :name="subscribeSourceDetailPrompt"
        :label="`${subscribeSourceDetailPrompt}${leadSourceDetailRequired ? '*' : ''}`"/>
      <dropdown-single-select
        v-else-if="leadSource && subscribeSourceDetailOptions"
        v-model="leadSourceDetail"
        class="leadSourceDetail dropdown"
        :class="{'mobile': isMobile, 'rejoin': isRejoin}"
        small
        :placeholder="`Select one${leadSourceDetailRequired ? '*' : ''}`"
        :dropdown-options="subscribeSourceDetailOptions"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DropdownSingleSelect from '../global/sequin/DropdownSingleSelect'
import { vuexAccessors } from '../global/helpers/vuex'
import { leadSourceOptions, rejoinOptions } from '@/store/modules/subscribe'
import BaseInput from '@/components/global/BaseInput.vue'
import useVuelidate from '@vuelidate/core'
import { requiredIf } from '@vuelidate/validators'
import { useSignUpNavigationStore } from '@/stores/signUpNavigation.js'

export default {
  components: {
    DropdownSingleSelect,
    BaseInput
  },
  setup () {
    const { isSignUpPhase3Route } = useSignUpNavigationStore()

    return {
      isSignUpPhase3Route,
      v$: useVuelidate()
    }
  },
  computed: {
    ...mapState('subscribe', [
      'referralCode'
    ]),
    ...mapState('client', [
      'membershipStatus'
    ]),
    ...vuexAccessors('subscribe', [
      'leadSource',
      'leadSourceDetail',
      'leadSourceDetailRequired'
    ]),
    isRejoin () {
      return this.membershipStatus === 'former_member'
    },
    subscribeSourcePrompt () {
      return this.isRejoin
        ? 'What brought you back to Armoire?'
        : 'How did you hear about Armoire?'
    },
    subscribeSourceOptions () {
      return this.isRejoin
        ? rejoinOptions
        : leadSourceOptions
    },
    selectionIndex () {
      return this.leadSource ? Math.max(this.subscribeSourceOptions.findIndex(subscribeSourceOption => subscribeSourceOption.value === this.leadSource), 0) : 0
    },
    subscribeSourceDetailPrompt () {
      return this.subscribeSourceOptions[this.selectionIndex].detailPrompt()
    },
    subscribeSourceDetailOptions () {
      return this.subscribeSourceOptions[this.selectionIndex].detailOptions
    }
  },
  validations () {
    return {
      leadSourceDetail: {
        required: requiredIf(function () {
          return this.leadSourceDetailRequired
        })
      }
    }
  },
  mounted () {
    if (this.referralCode) {
      this.leadSource = 'referral'
      this.leadSourceDetail = this.referralCode
    }
  },
  methods: {
    onLeadSourceUpdate (newValue) {
      if (this.leadSource !== newValue) this.leadSourceDetail = null
      this.leadSource = newValue
      this.leadSourceDetailRequired = !!this.subscribeSourceDetailPrompt || !!this.subscribeSourceDetailOptions
    }
  }
}
</script>

<style lang="scss" scoped>
.leadSourceDetail {
  width: 100%;
  &.mobile, &.rejoin {
    width: 100%;
    margin-top: 0;

    &.dropdown {
      margin-top: 4px;
    }
  }
}
:deep(.form-group) {
    margin-top: 0 !important;
    .input-group {
      margin-top: 0 !important;
    }
  }
.leadSource {
  margin-right: 16px;

  &.mobile, &.rejoin {
    width: 100%;
    margin-right: 0;
  }

}

.required-asterisk {
  color: $orchid;
  font-weight: normal;
}

</style>
